import apiService from './apiService';
import {
  LIVE_URL_TRACKINGS_API,
  LIVE_URL_TRACKINGS_STATS_API
} from '../../Constants';

const toUtcStartOfDay = (dateValue) => {
  if (!dateValue) return null;

  const dateOnly = String(dateValue).match(/^(\d{4}-\d{2}-\d{2})/);
  if (dateOnly) {
    return `${dateOnly[1]}T00:00:00.000Z`;
  }

  return dateValue instanceof Date ? dateValue.toISOString() : dateValue;
};

const toUtcEndOfDay = (dateValue) => {
  if (!dateValue) return null;

  const dateOnly = String(dateValue).match(/^(\d{4}-\d{2}-\d{2})/);
  if (dateOnly) {
    return `${dateOnly[1]}T23:59:59.999Z`;
  }

  return dateValue instanceof Date ? dateValue.toISOString() : dateValue;
};

const formatFilters = (filters = {}) => {
  const params = {};

  if (filters.rootFolder && Array.isArray(filters.rootFolder) && filters.rootFolder.length > 0) {
    params.rootFolder = filters.rootFolder.join(',');
  }
  if (filters.pushedBy) params.pushedBy = filters.pushedBy;

  if (filters.dateFrom) {
    params.dateFrom = toUtcStartOfDay(filters.dateFrom);
  }
  if (filters.dateTo) {
    params.dateTo = toUtcEndOfDay(filters.dateTo);
  }

  if (filters.fileType && Array.isArray(filters.fileType) && filters.fileType.length > 0) {
    params.fileType = filters.fileType.join(',');
  }

  params.sortBy = filters.sortBy || 'pushedAt';
  params.sortOrder = filters.sortOrder || 'desc';

  return params;
};

const formatPagination = (pagination = {}) => {
  return {
    page: pagination.currentPage || 1,
    limit: pagination.pageSize || 20
  };
};

const emptyRecordsPayload = () => ({
  records: [],
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalRecords: 0,
    pageSize: 20
  }
});

const emptyStatsPayload = () => ({
  totalRecords: 0,
  recordsByRootFolder: {},
  recordsByFileType: {},
  recordsByItemType: {},
  recentActivity: {
    lastPushAt: null,
    pushesToday: 0,
    pushesThisWeek: 0
  }
});

/**
 * Backend responses use { status_code, data: { ... } } (same as other /api endpoints).
 * Axios puts that body on response.data; unwrap the inner data for sagas/components.
 */
const unwrapApiPayload = (response) => {
  if (!response || !response.data) {
    return null;
  }

  const body = response.data;
  if (body && typeof body === 'object' && body.data !== undefined) {
    return body.data;
  }

  return body;
};

const validateResponse = (response, type = 'records') => {
  const payload = unwrapApiPayload(response);

  if (type === 'records') {
    if (!payload) {
      return { data: emptyRecordsPayload() };
    }

    return {
      data: {
        records: Array.isArray(payload.records) ? payload.records : [],
        pagination: payload.pagination && typeof payload.pagination === 'object'
          ? payload.pagination
          : emptyRecordsPayload().pagination
      }
    };
  }

  if (!payload) {
    return { data: emptyStatsPayload() };
  }

  return { data: payload };
};

const liveUrlTrackingApi = {
  fetchTrackingRecords: async (filters = {}, pagination = {}) => {
    const params = {
      ...formatFilters(filters),
      ...formatPagination(pagination)
    };

    const response = await apiService.get(LIVE_URL_TRACKINGS_API, { params });
    return validateResponse(response, 'records');
  },

  fetchTrackingStats: async (filters = {}) => {
    const params = formatFilters(filters);
    delete params.sortBy;
    delete params.sortOrder;

    const response = await apiService.get(LIVE_URL_TRACKINGS_STATS_API, { params });
    return validateResponse(response, 'stats');
  }
};

export default liveUrlTrackingApi;
